module.exports = __webpack_public_path__ + "media/assets/images/category/YouRock@2x-4aac365faba62118d6f37866143ea1eb.png";